import { Component, Input, Output, EventEmitter } from '@angular/core';
import { PaginationControlsComponent } from 'ngx-pagination';
import { PageRequest } from '@models/models';
import { PaginationService } from '@services/pagination/pagination.service';

@Component({
	selector: 'sn-new-pagination',
	template: require('./sn-new-pagination.html'),
	styles: [require('./sn-new-pagination.scss')]
})
export class SnNewPaginationComponent extends PaginationControlsComponent {
	@Input() pageRequest: PageRequest;
	@Input() pageNumbers: number;
	@Input() totalItems: number;
	@Input() id: string;
	@Input() maxSize: number;
	@Input() directionLinks: boolean;
	@Input() autoHide: boolean;
	@Input() responsive: boolean;
	@Input() previousLabel: string;
	@Input() nextLabel: string;
	@Input() screenReaderPaginationLabel: string;
	@Input() screenReaderPageLabel: string;
	@Input() screenReaderCurrentLabel: string;
	@Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
	@Output() pageBoundsCorrection: EventEmitter<any> = new EventEmitter<any>();

	pageOptions: number[] = [5, 10, 25, 50, 100];

	constructor(private paginationService: PaginationService) {
		super();
	}

	onPageChange(event: number, isCurrentPage: boolean): void {
		if (!isCurrentPage) {
			this.getNewPageRequest(event);
		}
	}

	onPageBoundsCorrection(event: number): void {
		this.pageBoundsCorrection.emit(event);
	}

	getCurrentPage(): number {
		return this.pageRequest.paging.pageNumber;
	}

	perPageChanged(newPerPage: number): void {
		this.getNewPageRequest(1, newPerPage);
	}

	private getNewPageRequest(pageNumber: number, perPage?: number): void {
		const newPageRequest = this.paginationService.getResultsPage(
			this.pageRequest,
			this.totalItems,
			pageNumber,
			perPage
		);
		if (newPageRequest) {
			this.pageChange.emit(newPageRequest);
		}
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/common/sn-new-pagination/sn-new-pagination.ts